import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.js';
import AppShell from '@/layouts/AppShell.jsx';
import LoginPage from '@/pages/auth/LoginPage.jsx';
import DashboardPage from '@/pages/dashboard/DashboardPage.jsx';
import EmployeesPage from '@/pages/employees/EmployeesPage.jsx';
import EmployeeFormPage from '@/pages/employees/EmployeeFormPage.jsx';
import EmployeeProfilePage from '@/pages/employees/EmployeeProfilePage.jsx';
import AttendancePage from '@/pages/attendance/AttendancePage.jsx';
import LeavePage from '@/pages/leave/LeavePage.jsx';
import OvertimePage from '@/pages/overtime/OvertimePage.jsx';
import ShortLeavePage from '@/pages/short-leave/ShortLeavePage.jsx';
import LoansPage from '@/pages/loans/LoansPage.jsx';
import AdvancesPage from '@/pages/advances/AdvancesPage.jsx';
import SalaryHoldsPage from '@/pages/salary-holds/SalaryHoldsPage.jsx';
import PayrollRunsPage from '@/pages/payroll/PayrollRunsPage.jsx';
import PayrollRunDetailPage from '@/pages/payroll/PayrollRunDetailPage.jsx';
import AllowancesMonthPage from '@/pages/payroll/AllowancesMonthPage.jsx';
import DeductionsMonthPage from '@/pages/payroll/DeductionsMonthPage.jsx';
import ReportsPage from '@/pages/reports/ReportsPage.jsx';
import AuditLogPage from '@/pages/audit/AuditLogPage.jsx';
import DepartmentsPage from '@/pages/settings/DepartmentsPage.jsx';
import DesignationsPage from '@/pages/settings/DesignationsPage.jsx';
import PayGradesPage from '@/pages/settings/PayGradesPage.jsx';
import HolidaysPage from '@/pages/settings/HolidaysPage.jsx';
import LeaveTypesPage from '@/pages/settings/LeaveTypesPage.jsx';
import SalaryComponentsPage from '@/pages/settings/SalaryComponentsPage.jsx';
import CompanySettingsPage from '@/pages/settings/CompanySettingsPage.jsx';
import TaxTablesPage from '@/pages/settings/TaxTablesPage.jsx';
import UsersPage from '@/pages/settings/UsersPage.jsx';
import MasterDetailsHub from '@/pages/settings/MasterDetailsHub.jsx';
import HRPoliciesHub from '@/pages/settings/HRPoliciesHub.jsx';
import PreferenceHub from '@/pages/settings/PreferenceHub.jsx';

function PrivateRoute({ children }) {
  const token = useAuthStore((s) => s.token);
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <AppShell />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />

        <Route path="employees" element={<EmployeesPage />} />
        <Route path="employees/new" element={<EmployeeFormPage />} />
        <Route path="employees/:id/edit" element={<EmployeeFormPage />} />
        <Route path="employees/:id" element={<EmployeeProfilePage />} />

        <Route path="attendance" element={<AttendancePage />} />
        <Route path="leave" element={<LeavePage />} />
        <Route path="overtime" element={<OvertimePage />} />
        <Route path="short-leave" element={<ShortLeavePage />} />

        <Route path="loans" element={<LoansPage />} />
        <Route path="advances" element={<AdvancesPage />} />
        <Route path="salary-holds" element={<SalaryHoldsPage />} />

        <Route path="payroll" element={<PayrollRunsPage />} />
        <Route path="payroll/:id" element={<PayrollRunDetailPage />} />
        <Route path="payroll/allowances" element={<AllowancesMonthPage />} />
        <Route path="payroll/deductions" element={<DeductionsMonthPage />} />

        <Route path="reports" element={<ReportsPage />} />
        <Route path="audit" element={<AuditLogPage />} />

        {/* Hub routes — new 3-item Settings sidebar */}
        <Route path="settings/master" element={<MasterDetailsHub />} />
        <Route path="settings/hr-policies" element={<HRPoliciesHub />} />
        <Route path="settings/preference" element={<PreferenceHub />} />

        {/* Legacy individual settings routes (kept for direct linking) */}
        <Route path="settings/company" element={<CompanySettingsPage />} />
        <Route path="settings/users" element={<UsersPage />} />
        <Route path="settings/departments" element={<DepartmentsPage />} />
        <Route path="settings/designations" element={<DesignationsPage />} />
        <Route path="settings/pay-grades" element={<PayGradesPage />} />
        <Route path="settings/holidays" element={<HolidaysPage />} />
        <Route path="settings/leave-types" element={<LeaveTypesPage />} />
        <Route path="settings/salary-components" element={<SalaryComponentsPage />} />
        <Route path="settings/tax-tables" element={<TaxTablesPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
